<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-row>
        <v-col>
          <h2 class="accent--text">Evolution de l'alerte</h2>

          <apexchart
            type="line"
            :options="chartOptions"
            :series="chartSeries"
            height="350"
          ></apexchart>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { applyAggregation } from "@/services/rule";

export default {
  props: {
    alertData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartOptions: function () {
      const options = {
        chart: {
          id: "alertdetail-chart",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: this.chartData.dates,
        },
        // stroke: {
        //   curve: "smooth",
        // },
        colors: ["#7AB2E1", "#F28C00"],
        fill: {
          opacity: 1,
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
      };

      return options;
    },

    chartSeries: function () {
      const series = [
        {
          name: `${this.alertData.rule.value} quotidien`,
          data: this.chartData.value,
          type: "column",
        },
        {
          name: `${this.alertData.rule.value} cumulé`,
          data: this.chartData.cumul,
          type: "line",
        },
      ];

      return series;
    },

    chartData: function () {
      const alerts = [this.alertData].concat(this.alertData.previous).reverse();

      let cumul = 0;

      const chart = alerts.reduce(
        (acc, val, i) => {
          const nextObject = alerts[i + 1];
          const nextDate = nextObject && nextObject.date;

          const diff = Math.abs(dayjs(val.date).diff(dayjs(nextDate), "day"));

          cumul = applyAggregation(val.rule.val_aggregation, cumul, val.value);

          acc.dates.push(dayjs(val.date).format("DD/MM/YYYY"));
          acc.cumul.push(cumul);
          acc.value.push(val.value);

          if (nextDate && diff > 1) {
            for (let i = 1; i < diff; i++) {
              acc.dates.push(
                dayjs(val.date).add(i, "day").format("DD/MM/YYYY")
              );
              acc.cumul.push(cumul);
              acc.value.push(0);
            }
          }

          return acc;
        },
        { dates: [], cumul: [], value: [] }
      );

      return chart;
    },
  },
};
</script>
